export default __webpack_public_path__ + "static/media/AdobeStock_298891216_x3.9764292b.jpg";